import { ChevronDownRegularIcon, VideoRegularIcon } from "@elixir/icons";
import { Popover } from "antd";
import { AddNewAptFieldLayoutUi } from "ui";
import useQueueStore from "../../../../stores/queue-store";
import { MODES_OF_APT } from "../../../../stores/queue-store/enums";
import { SupportedTeleProvidersLabel } from "@elixir/types";
import TelePlatformsPopover from "./tele-platform-popover";
import useTeleConfigurationStore from "../../../../stores/vc-meta-store";

function SelectTelePlatform() {
  const showTelePlatformPopup = useTeleConfigurationStore(
    (state) => state.showTeleConfigurationPopup
  );
  const setShowTelePlatformPopup = useTeleConfigurationStore(
    (state) => state.setShowTeleConfigurationPopup
  );

  const mode = useQueueStore((state) => state.mode);
  const vcPlatform = useQueueStore((state) => state.vcMeta.platform);

  if (mode !== MODES_OF_APT.TELE) {
    return null;
  }

  return (
    <AddNewAptFieldLayoutUi
      title="Platform"
      Icon={<VideoRegularIcon className="dr-w-14 dr-h-14 dr-min-w-14" />}
    >
      <Popover
        trigger={"click"}
        content={<TelePlatformsPopover />}
        placement="rightTop"
        className="dr-cursor-pointer"
        destroyTooltipOnHide={true}
        overlayClassName="fd-popup"
        open={showTelePlatformPopup}
        onOpenChange={(visible) => {
          if (visible) {
            const queueStore = useQueueStore.getState();

            setShowTelePlatformPopup({
              showTeleConfigurationPopup: visible,
              hostLink: queueStore.vcMeta?.host_link,
              meetLink: queueStore.vcMeta?.meet_link,
              platform: queueStore.vcMeta?.platform,
            });
          } else {
            setShowTelePlatformPopup({
              showTeleConfigurationPopup: visible,
            });
          }
        }}
      >
        <div className="dr-flex dr-items-center dr-justify-between BodyRegular dr-min-h-40 dr-h-40 dr-border dr-border-darwin-neutral-200 dr-rounded-8 dr-w-full dr-px-11 dr-cursor-pointer dr-text-darwin-primary-primary dr-bg-darwin-neutral-0">
          <p>{SupportedTeleProvidersLabel[vcPlatform]}</p>
          <ChevronDownRegularIcon className="-dr-rotate-90 dr-w-14 dr-h-14 dr-min-w-14 dr-min-h-14" />
        </div>
      </Popover>
    </AddNewAptFieldLayoutUi>
  );
}

export default SelectTelePlatform;
